module.exports = __webpack_public_path__ + "static/images/empty-backpack3.ddfc0d0.png";